import { render, staticRenderFns } from "./project.item.vue?vue&type=template&id=1a91c418&scoped=true&"
import script from "./project.item.vue?vue&type=script&lang=js&"
export * from "./project.item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91c418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a91c418')) {
      api.createRecord('1a91c418', component.options)
    } else {
      api.reload('1a91c418', component.options)
    }
    module.hot.accept("./project.item.vue?vue&type=template&id=1a91c418&scoped=true&", function () {
      api.rerender('1a91c418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/project.item.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.item.vue
// module id = 804
// module chunks = 2